import { render } from "./TableWithBorder.vue?vue&type=template&id=9b02641a"
import script from "./TableWithBorder.vue?vue&type=script&lang=js"
export * from "./TableWithBorder.vue?vue&type=script&lang=js"
script.render = render

export default script